import {usePreloadedQuery} from 'react-relay'
import type {PreloadedQuery} from 'react-relay/relay-hooks/EntryPointTypes'

import {useAppSelector} from '../../../../hooks/react-redux'
import {getOverviewHref} from '../../../../routes'
import {getBuild} from '../../../../selectors'
import type {BuildId} from '../../../../types'
import {useSequenceLoaderReadyHandler} from '../../SequenceLoader/SequenceLoader.hooks'

import type {SnapshotDependenciesCountersQuery} from './__generated__/SnapshotDependenciesCountersQuery.graphql'
import SnapshotDependenciesCounters from './SnapshotDependenciesCounters'
import {useSnapshotDependenciesCounters} from './SnapshotDependenciesCounters.hooks'
import {snapshotDependenciesCountersQuery} from './SnapshotDependenciesCounters.queries'

type Props = {
  buildId?: BuildId | null | undefined
  queryRef: PreloadedQuery<SnapshotDependenciesCountersQuery>
}

export default function SnapshotDependenciesCountersContainer({buildId, queryRef}: Props) {
  const {builds = null} = usePreloadedQuery(snapshotDependenciesCountersQuery, queryRef)
  useSequenceLoaderReadyHandler(true)
  const overallCount = builds?.count ?? 0
  const {
    finishedFailed,
    finishedSuccessful,
    queued,
    canceled,
    failedToStart,
    runningFailed,
    runningSuccessful,
    overdue,
  } = useSnapshotDependenciesCounters(builds)
  const buildTypeId = useAppSelector(state => getBuild(state, buildId)?.buildType)

  return (
    <SnapshotDependenciesCounters
      overallCount={overallCount}
      finishedFailed={finishedFailed}
      finishedSuccessful={finishedSuccessful}
      queued={queued}
      canceled={canceled}
      failedToStart={failedToStart}
      runningFailed={runningFailed}
      runningSuccessful={runningSuccessful}
      overdue={overdue}
      dependenciesTabLink={`${getOverviewHref({
        buildId,
        buildTypeId,
      })}?buildTab=dependencies`}
    />
  )
}
